export default "__VITE_ASSET__a1087abb__"